/*
 * LaFlore: Judge.me preview-badge -> review-widget scroll bridge
 *
 * Clicking the star badge under the product title is supposed to jump to the
 * review list. Judge.me implements that itself, and their implementation is
 * fine -- it just cannot work inside Horizon's desktop shell.
 *
 * What their handler does (read from widget_base.js, confirmed live on the
 * serum PDP by instrumenting the page): the click resolves the target and
 * calls `jdgm.scrollTo($('#judgeme_product_reviews'), 30)`, which is
 * `$('html,body').animate({ scrollTop: target.offset().top - 30 })`.
 *
 * Above 990px Horizon's base.css locks html and body to `height: 100dvh;
 * overflow: hidden` and scrolls .page-wrapper instead. Measured there:
 * document.scrollingElement scrollHeight === clientHeight === 900, so html and
 * body have nothing to scroll and the animation lands on zero. The badge click
 * fires, the analytics fire, and the page does not move. Below 990px the
 * document scrolls normally and their handler already works (measured at 390:
 * window.scrollY 0 -> 5431, widget 58px below the viewport top).
 *
 * So this is a fallback, not a replacement. It engages only when the document
 * genuinely cannot scroll -- the exact condition that breaks their code -- and
 * stays out of the way everywhere else, so the two never animate at once. The
 * gate is measured rather than a breakpoint, so it follows the shell if Horizon
 * moves that 990px threshold, and it disengages on its own if Judge.me ever
 * ships a scroll that works here.
 *
 * scrollIntoView (rather than scrolling .page-wrapper by hand) is what makes
 * this shell-agnostic: it scrolls whichever ancestors actually scroll, so the
 * theme's scroll container is never named here. The landing offset comes from
 * `scroll-margin-top` on the widget, set in laflore.css off Horizon's own live
 * --header-height, so the list does not arrive under the sticky header.
 *
 * The listener is delegated from document because Judge.me re-renders its own
 * DOM, and it never calls stopPropagation or preventDefault -- their handler
 * still runs, keeping their widget-click tracking intact; its scroll is simply
 * a no-op in this branch. With no Judge.me on the store (the dev store) nothing
 * matches and this costs one document listener.
 */
(function () {
  // Judge.me's own interactive element (role="button", keyboard-activated by
  // their script). The --with-link modifier is their "badge links to the
  // reviews" setting: if a merchant turns it off in Judge.me, the badge is not
  // meant to navigate, and this bridge must respect that rather than override it.
  var BADGE = '.jdgm-prev-badge';
  var LINK_MODE = '.jdgm-preview-badge--with-link';
  var WIDGET = '#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg';

  function documentScrolls() {
    var scroller = document.scrollingElement || document.documentElement;
    return scroller.scrollHeight - scroller.clientHeight > 1;
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var badge = target.closest(BADGE);
      if (!badge || !badge.closest(LINK_MODE)) return;

      // Their handler can do the job here; leave it to them.
      if (documentScrolls()) return;

      var widget = document.querySelector(WIDGET);
      if (!widget) return;

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      widget.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
    },
    true
  );
})();
